<template>
    <div>
        <div v-if="(sessionProducts.length) == 0">
            There are no issues <br> Thats all :)
        </div>
        <div v-else>
            <div class="support-tickets-header" v-if="showCloseMessage">
                <div class="tickets-control">
                    <div class="">
                        There are products with issues we recommend should be resolved before closing the session
                    </div>
                    <div class="element-search">
                        <a class="btn btn-primary">Close Anyways</a>
                    </div>
                </div>
            </div>
            <div class="support-ticket" v-for="product in sessionProducts">
                <div class="st-meta">
                    <i class="fas fa-trash text-danger  " v-if="product.product_deleted_at !== null"></i>
                    <i class="fas fa-check-circle" v-if="isQCApproved(product) == 1" :class="'qc-'+isQCApproved(product)"></i>
                    <i class="fas fa-times-circle" v-if="isQCRejected(product) == 1" :class="'qc-'+isQCRejected(product)"></i>
                </div>
                <div class="st-body">
                    <div class="avatar">
                        <img alt="" :src="product.preview">
                    </div>
                    <div class="col-sm-4">
                        <div class="ticket-content">
                            <h6 class="ticket-title">
                                {{productDisplayName(product)}}
                            </h6>
                            <div class="ticket-description">
                                {{product.item_identifier}}
                                <br> {{product.brand}}
                                <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 b-r">
                        <div class="el-tablo centered padded-v">
                            <div class="value" :class="'qc-'+isShot(product)">{{product.final_count}}</div>
                            <div class="label">Images Allocated</div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <table class="table table-v-compact mb-0">
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>{{product.image_count}}</strong>
                                        <div class="balance-label smaller lighter text-nowrap">Shot</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{{product.image_deleted}}</strong>
                                        <div class="balance-label smaller lighter text-nowrap">Deleted</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="st-foot">

                    <span v-if="product.model_name" class="label">Model:</span>
                    <a class="value with-avatar" v-if="product.model_name">
                        <img alt="" :src="'http://52.66.102.131/'+product.model_avatar">
                        <span>{{product.model_name}}</span>
                    </a>
                    <span class="label">Category:</span>
                    <span class="value"> {{product.category_name}} </span>

                    <span class="pull-right">
                        <router-link tag="a" :to="`/productdesk/product/${product.id_product}`">
                            View Details
                        </router-link>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Product from '@/mixins/product'

export default {
  props: ['products', 'showMessage'],
  mixins: [Product],
  data: function () {
    return {
      sessionProducts: '',
      showCloseMessage: false
    }
  },
  mounted: function () {
    this.showCloseMessage = this.showMessage
    this.filterProducts()
  },
  destroyed: function () {
    this.showCloseMessage = false
  },
  methods: {
    updateProductDetailsContainer: function (product) {
      this.$emit('productInterface', product)
    },
    isQCApproved: function (product) {
      return product.is_qc_complete == 1 && product.is_qc_approve == 1 ? 1 : 0
    },
    isQCRejected: function (product) {
      return product.is_qc_complete == 1 && product.is_qc_approve == 0 ? 1 : 0
    },
    isShot: function (product) {
      return product.final_count > 0 ? 1 : 0
    },
    onChange: function () {
      var self = this
      this.filterProducts()
    },
    filterProducts: function () {
      var self = this
      const filter = self.products.filter(value => {
        return value.final_count == 0
      })
      self.sessionProducts = filter
    }
  },
  watch: {
    products () {
      this.filterProducts()
    }
  }
}
</script>

<style>
.support-index .support-tickets {
  padding-right: 20px;
  margin-right: 00px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}
.qc-1 {
  color: #75da62 !important;
}

.qc-0 {
  color: #da6262 !important;
}

.flagged {
  color: #ffc107 !important;
}

.pull-right {
  float: right;
}

.droptext {
  font-weight: bold !important;
  margin-right: 10px;
}
</style>
